import {
    GET_ALL_VENDOR
} from './constants';

const initialState = {
    allVendors: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_VENDOR: {
            return {
                ...state,
                allVendors: action.payload,
            };
        }
        default:
            return state;
    }
};

